import { Suspense, lazy, useState, useEffect } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';

// @Utility
import readMenuIcon from "@utility/app/readMenuIcon";

// Hooks
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import useEffectOnce from '@utility/hooks/useEffectOnce';

// Redux & Action
import { useSelector, useDispatch } from 'react-redux';
import { loadHomeData } from "@core/redux/actions/home/index";
// import { setDataAlert } from "@core/redux/actions/app/alert";

// Auth Services
import { isUserLoggedIn } from "@core/auth/utils";

// Component
import Navbar from "./component/Navbar";
import BannerSlide from "./component/BannerSlide";
import FooterText from "./component/FooterText";
import FooterTabMenu from "./component/FooterTabMenu";
import PromotionPopup from "views/components/PromotionPopup";
import ImageShow from "views/components/ImageShow";

// Style & CSS
import "assets/css/Bagde.css";
import "./Page.css";

// Page Routes
const HomeApp = lazy(() => import("./pages/home/index"));
const AffiateApp = lazy(() => import("./pages/affiate/index"));
const CashbackApp = lazy(() => import("./pages/cashback/index"));
const DepositApp = lazy(() => import("./pages/deposit/index"));
const PromotionApp = lazy(() => import("./pages/promotion/index"));
const WithdrawApp = lazy(() => import("./pages/withdraw/index"));
const HistoryApp = lazy(() => import("./pages/history/index"));
const TableStandardApp = lazy(() => import("./pages/history/TableStandard"));
const BagApp = lazy(() => import("./pages/bag/index"));
const ContactApp = lazy(() => import("./pages/contact/index"));
const ProfileApp = lazy(() => import("./pages/profile/Profile"));
// const AddBank = lazy(() => import("../../components/Profile/AddBank"));
const ChangePasswordApp = lazy(() => import("./pages/profile/ChangePass"));
const WheelSpin = lazy(() => import("./pages/wheel-spin/index"));
const ActivityApp = lazy(() => import("./pages/activity/index"));
const OfflineApp = lazy(() => import("./pages/offline/index"));
const OpenGameApp = lazy(() => import("./pages/open-game/index"));

const PageRoute = () => {
    const dataSetting = useSelector(state => state.reduxAppDataSetting.result);
    const reduxPromotionPopup = useSelector(state => state.reduxPromotion);
    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
    const [fadeIn, setFadeIn] = useState(false);
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const history = useNavigate();

    const routesRouter = (dataSetting) => {
        return (
            <Suspense fallback={null}>
                <Routes>
                    {
                        isUserLoggedIn() && (
                            <>
                                <Route path="/activity" element={<ActivityApp dataSetting={dataSetting} />} exact />
                                <Route path="/wheel" element={<WheelSpin dataSetting={dataSetting} />} exact />
                                <Route path="/bag" element={<BagApp dataSetting={dataSetting} />} exact />
                                <Route path="/withdraw" element={<WithdrawApp dataSetting={dataSetting} />} exact />
                                <Route path="/deposit" element={<DepositApp dataSetting={dataSetting} />} exact />
                                <Route path="/cashback" element={<CashbackApp dataSetting={dataSetting} />} exact />
                                <Route path="/affiate" element={<AffiateApp dataSetting={dataSetting} />} exact />
                                <Route path="/history" element={<HistoryApp dataSetting={dataSetting} />} exact />
                                <Route path="/history/:tableTypes" element={<TableStandardApp dataSetting={dataSetting} />} exact />
                                <Route path="/profile" element={<ProfileApp dataSetting={dataSetting} exact />} />
                                {/* <Route path="/profile/addbank" element={<AddBank dataSetting={dataSetting} exact />} /> */}
                                <Route path="/password" element={<ChangePasswordApp dataSetting={dataSetting} exact />} />
                            </>
                        )
                    }

                    <Route path="/offline" element={<OfflineApp dataSetting={dataSetting} />} exact />
                    <Route path="/contact" element={<ContactApp dataSetting={dataSetting} />} exact />
                    <Route path="/promotion" element={<PromotionApp dataSetting={dataSetting} />} exact />
                    {/* <Route path="/history" element={<HistoryApp dataSetting={dataSetting} />} exact /> */}
                    {/* <Route path="/history/:tableType" exact>
                        <TableStandard></TableStandard>
                    </Route> */}
                    <Route path="/:random/affiliate/:code" element={<HomeApp dataSetting={dataSetting} isLargeScreen={isLargeScreen} />} exact />
                    <Route path="/:random/refer/:code" element={<HomeApp dataSetting={dataSetting} isLargeScreen={isLargeScreen} />} exact />
                    <Route path="/:random/ref/:code" element={<HomeApp dataSetting={dataSetting} isLargeScreen={isLargeScreen} />} exact />
                    <Route path="/:random/market/:code" element={<HomeApp dataSetting={dataSetting} isLargeScreen={isLargeScreen} />} exact />
                    <Route path="/" element={<HomeApp dataSetting={dataSetting} isLargeScreen={isLargeScreen} />} exact />
                    <Route path="*" element={<Navigate replace to="/" />} />
                </Routes>
            </Suspense>
        );
    };

    const routesRouterOpenGame = (dataSetting) => {
        return (
            <Suspense fallback={null}>
                <Routes>
                <Route path="/open-game/html" element={<OpenGameApp />} exact />
                    <Route path="/" element={<HomeApp dataSetting={dataSetting} isLargeScreen={isLargeScreen} />} exact />
                    <Route path="*" element={<Navigate replace to="/" />} />
                </Routes>
            </Suspense>
        );
    };

    useEffect(() => {
        setFadeIn(false);

        setTimeout(() => {
            setFadeIn(true);
        }, 200);
    }, [pathname]);

    useEffectOnce(() => {
        if (pathname !== "/open-game/html") {
            if (isUserLoggedIn()) {
                dispatch(loadHomeData());
            }
        }
        // dispatch(setDataAlert({
        //     type: "success",
        //     title: "สมัครสมาชิกสำเร็จ",
        //     text: null,
        //     action: {
        //         select: "register",
        //         username: "Test",
        //         password: 1234
        //     },
        //     redirect: "",
        //     show: true,
        //     buttonText: null
        // }));
    }, [pathname, isUserLoggedIn()]);

    return (
        <>
            {
                (pathname !== "/open-game/html" && dataSetting !== null) && (
                    <>
                        <div className="pageContent">
                            <Navbar dataSetting={dataSetting} isLargeScreen={isLargeScreen} isUserLoggedIn={isUserLoggedIn}></Navbar>
        
                            <div className={pathname === "/" ? "contentMarginHome" : "contentMargin"}>
                                <BannerSlide dataSetting={dataSetting} isLargeScreen={isLargeScreen} pathname={pathname} isUserLoggedIn={isUserLoggedIn}></BannerSlide>
        
                                <div className={fadeIn ? "fadeIn" : "fadeInHide"}>
                                    <div className="boxMarginTop">
                                        {
                                            routesRouter(dataSetting)
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <FooterText></FooterText>
        
                        {
                            isUserLoggedIn() && (
                                <FooterTabMenu dataCms={dataSetting?.cms}></FooterTabMenu>
                            )
                        }
        
                        {
                            reduxPromotionPopup.show && (
                                <PromotionPopup reduxPromotionPopup={reduxPromotionPopup}></PromotionPopup>
                            )
                        }
        
                        {
                            !isUserLoggedIn() && (
                                <div className="positionFixed bottomRight zIndexMedium">
                                    <ImageShow className="imgContactSize cursorPointer positionRelative" src={readMenuIcon(dataSetting?.cms?.image_contact, "/images/contact.webp")} altText="ติดต่อเรา" onClick={() => history("/contact")}></ImageShow>
                                </div>
                            )
                        }
                    </>
                )
            }

            {
                (pathname === "/open-game/html" && dataSetting !== null) && (
                    routesRouterOpenGame(dataSetting)
                )
            }
        </>
    );
};

export default PageRoute;